import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NvIconModule } from '../../design/nv-icon/nv-icon.module';
import { NvBoxComponent } from './nv-box.component';
import { NvAriaLabelModule } from '../directives/nv-aria-label/nv-aria-label.module';

@NgModule({
  declarations: [NvBoxComponent],
  exports: [NvBoxComponent],
  imports: [CommonModule, NvIconModule, NvAriaLabelModule],
})
export class NvBoxModule {}
